import * as Types from '../../../../../../__generated__/schema';

import { RuleDetails } from '../../../../../graphql/fragments/RuleDetails.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRuleVariables = Types.Exact<{
  input: Types.GetRuleInput;
}>;

export type GetRule = { rule?: Types.Maybe<RuleDetails> };

export type UpdateRuleVariables = Types.Exact<{
  input: Types.UpdateRuleAndFilterInput;
}>;

export type UpdateRule = { updateRuleAndFilter?: Types.Maybe<RuleDetails> };

export type CreatePullRequestVariables = Types.Exact<{
  input: Types.CreatePullRequestForRuleEditInput;
}>;

export type CreatePullRequest = {
  createPullRequestForRuleEdit?: Types.Maybe<Pick<Types.CreatePullRequestResponse, 'url'>>;
};

export const GetRuleDocument = gql`
  query GetRule($input: GetRuleInput!) {
    rule(input: $input) {
      ...RuleDetails
    }
  }
  ${RuleDetails}
`;

/**
 * __useGetRule__
 *
 * To run a query within a React component, call `useGetRule` and pass it any options that fit your needs.
 * When your component renders, `useGetRule` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRule({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRule(baseOptions: Apollo.QueryHookOptions<GetRule, GetRuleVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRule, GetRuleVariables>(GetRuleDocument, options);
}
export function useGetRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRule, GetRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRule, GetRuleVariables>(GetRuleDocument, options);
}
export function useGetRuleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRule, GetRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRule, GetRuleVariables>(GetRuleDocument, options);
}
export type GetRuleHookResult = ReturnType<typeof useGetRule>;
export type GetRuleLazyQueryHookResult = ReturnType<typeof useGetRuleLazyQuery>;
export type GetRuleSuspenseQueryHookResult = ReturnType<typeof useGetRuleSuspenseQuery>;
export type GetRuleQueryResult = Apollo.QueryResult<GetRule, GetRuleVariables>;
export const UpdateRuleDocument = gql`
  mutation UpdateRule($input: UpdateRuleAndFilterInput!) {
    updateRuleAndFilter(input: $input) {
      ...RuleDetails
    }
  }
  ${RuleDetails}
`;
export type UpdateRuleMutationFn = Apollo.MutationFunction<UpdateRule, UpdateRuleVariables>;

/**
 * __useUpdateRule__
 *
 * To run a mutation, you first call `useUpdateRule` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRule` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRule, { data, loading, error }] = useUpdateRule({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRule(
  baseOptions?: Apollo.MutationHookOptions<UpdateRule, UpdateRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRule, UpdateRuleVariables>(UpdateRuleDocument, options);
}
export type UpdateRuleHookResult = ReturnType<typeof useUpdateRule>;
export type UpdateRuleMutationResult = Apollo.MutationResult<UpdateRule>;
export type UpdateRuleMutationOptions = Apollo.BaseMutationOptions<UpdateRule, UpdateRuleVariables>;
export const CreatePullRequestDocument = gql`
  mutation CreatePullRequest($input: CreatePullRequestForRuleEditInput!) {
    createPullRequestForRuleEdit(input: $input) {
      url
    }
  }
`;
export type CreatePullRequestMutationFn = Apollo.MutationFunction<
  CreatePullRequest,
  CreatePullRequestVariables
>;

/**
 * __useCreatePullRequest__
 *
 * To run a mutation, you first call `useCreatePullRequest` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePullRequest` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPullRequest, { data, loading, error }] = useCreatePullRequest({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePullRequest(
  baseOptions?: Apollo.MutationHookOptions<CreatePullRequest, CreatePullRequestVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePullRequest, CreatePullRequestVariables>(
    CreatePullRequestDocument,
    options,
  );
}
export type CreatePullRequestHookResult = ReturnType<typeof useCreatePullRequest>;
export type CreatePullRequestMutationResult = Apollo.MutationResult<CreatePullRequest>;
export type CreatePullRequestMutationOptions = Apollo.BaseMutationOptions<
  CreatePullRequest,
  CreatePullRequestVariables
>;
export function mockGetRule({
  data,
  variables,
  errors,
}: {
  data: GetRule;
  variables?: GetRuleVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetRuleDocument, variables },
    result: { data, errors },
  };
}
export function mockUpdateRule({
  data,
  variables,
  errors,
}: {
  data: UpdateRule;
  variables?: UpdateRuleVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateRuleDocument, variables },
    result: { data, errors },
  };
}
export function mockCreatePullRequest({
  data,
  variables,
  errors,
}: {
  data: CreatePullRequest;
  variables?: CreatePullRequestVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: CreatePullRequestDocument, variables },
    result: { data, errors },
  };
}
